module.exports = __webpack_public_path__ + "static/media/NftACollage.4b265c4e.webp";